export class Controller {

    /** @ngInject */
    constructor(Alert, ApplicationAccountsResource, GroupsResource) {
        this.Alert = Alert;
        this.ApplicationAccountsResource = ApplicationAccountsResource;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        this.accounts = [];
        this.isLoading = true;
        const {applicationId, companyId, groupId,isComputerApplication,isAdPassEditableApplication,adPasswordViewSupported} = this.resolve;
        this.isAdApplication=isAdPassEditableApplication;

        this.GroupsResource
            .getApplicationGroupAccountCredentials(companyId, groupId, applicationId)
            .then(dto => {
                this.policy = dto.applicationPasswordPolicy;
                this.accounts = dto.appAccountPasswords;
                var cantSeePassPart1=false;
                var canEditPassPart1=false;
                if(this.policy !== null) {
                	
                	cantSeePassPart1=!this.policy.adminCanSeePassword;
                	canEditPassPart1=!this.policy.adminCanSetPassword;
                }
                this.adminCantSeePass=cantSeePassPart1 || (isComputerApplication && isAdPassEditableApplication && !adPasswordViewSupported);
                this.readOnlyPass=canEditPassPart1 || (isComputerApplication && !isAdPassEditableApplication);
            })
            .finally(() => this.isLoading = false);
    }

    saveEmail(account, email) {
        const {applicationId, companyId} = this.resolve;
        const accId = account.companyUserAccountId;
        return this.ApplicationAccountsResource
            .setPasswordResetEmailForAppAccount(companyId, applicationId, accId, email)
            .then(() => account.resetEmail = email)
            .then(() => this.Alert('success', 'company.manage-application.users.manage-passwords.saved'));
    }

    generatePassword(account) {
        const {applicationId, companyId} = this.resolve;
        const accId = account.companyUserAccountId;
        return this.ApplicationAccountsResource
            .generatePasswordForAppAccount(companyId, applicationId, accId);
    }

    savePassword(account, password) {
        const {applicationId, companyId} = this.resolve;
        const accId = account.companyUserAccountId;
        return this.ApplicationAccountsResource
            .setPasswordForAppAccount(companyId, applicationId, accId, password)
            .then(() => {
                account.password = password;
                this.Alert('success', 'company.manage-application.users.manage-passwords.saved');
            });
    }

    sendReset(account) {
        const {applicationId, companyId} = this.resolve;
        const accId = account.companyUserAccountId;
        this.sendingResetForAccount = account;
        this.ApplicationAccountsResource
            .sendPasswordResetEmailForAppAccount(companyId, applicationId, accId)
            .then(() => this.Alert('success', 'company.manage-application.users.manage-passwords.sent'))
            .finally(() => this.sendingResetForAccount = null);
    }

    sendResetClass(account) {
        return this.sendingResetForAccount === account ? 'fa fa-sync fa-spin' : 'fa fa-envelope';
    }

    sendResetDisabled(account) {
        return !account.resetEmail || this.sendingResetForAccount === account;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/manage-passwords/manage-passwords.controller.js